/**
 * This file was generated by TypeScriptGen v0.0.3
 * Any changes to this file will be lost if regenerated 
 */

enum PermissionEnum {
    ManagementRolesPermissions = "ManagementRolesPermissions",
    ManagementCultivarPermission = "ManagementCultivarPermission",
    ManagementLanguagePermission = "ManagementLanguagePermission",
    FertiliserProductsPermission = "FertiliserProductsPermission",
    ManagementFarmsPermission = "ManagementFarmsPermission",
    ManagementClientsPermission = "ManagementClientsPermission",
    ManagementUsersPermission = "ManagementUsersPermission",
    ManagementCategoryPermission = "ManagementCategoryPermission",
    FertiliserProgramsPermission = "FertiliserProgramsPermission",
    FertiliserApprovalsPermission = "FertiliserApprovalsPermission",
    FertiliserTemplatesPermission = "FertiliserTemplatesPermission",
    ManagementCropPermission = "ManagementCropPermission",
    ManagementAgentPermission = "ManagementAgentPermission",
    ManagementDistributorPermission = "ManagementDistributorPermission",
    ManagementSyncPermission = "ManagementSyncPermission",
    ManagementCompanyPermission = "ManagementCompanyPermission",
    ManagementAddress = "ManagementAddress",
    ManagementRegions = "ManagementRegions",
    FertiliserProgramsRemovePermission = "FertiliserProgramsRemovePermission",
    ManageErrors = "ManageErrors",
    ManagementCurrenciesPermission = "ManagementCurrenciesPermission",
    FertiliserCopyProgramsPermission = "FertiliserCopyProgramsPermission",
    LimingProgramsPermission = "LimingProgramsPermission",
    LimingApprovalsPermission = "LimingApprovalsPermission",
    LimingTemplatesPermission = "LimingTemplatesPermission",
    LimingProductsPermission = "LimingProductsPermission",
    LimingProgramsRemovePermission = "LimingProgramsRemovePermission",
    LimingCopyProgramsPermission = "LimingCopyProgramsPermission",
    LimingRegionsPermission = "LimingRegionsPermission"
}

export default PermissionEnum;
